<template>
    <c-dialog ref="dialog" width="650" enable-flex mask-close @close="clearTimers">
        <div class="m-repay-pay-body">
            <!-- 还款信息 -->
            <div class="m-repay-pay-info flex-center">
                <span class="m-repay-pay-info-label">还款金额：</span>
                <span class="m-repay-pay-info-value">{{formatPrice(amount)}}</span>
            </div>
            <!--服务费：本次还款各订单服务费合计（订单应还金额×2.6‰，不足1分不收取）-->
<!--            <div v-if="fee > 0" class="m-repay-pay-info flex-center">
                <span class="m-repay-pay-info-label">服务费(2.6‰)：</span>
                <span class="m-repay-pay-info-value">{{formatPrice(fee)}}</span>
            </div>-->
            <p class="m-repay-pay-no">还款单号：{{record_no}}</p>

            <!-- 扫码方式选择 -->
            <div class="m-repay-pay-tabs flex-center">
                <div v-for="item in payMethodOptions" :key="item.value"
                     class="m-repay-pay-tab" :class="{'z-active': payMethod == item.value}"
                     @click="switchPayMethod(item.value)">{{item.name}}</div>
            </div>

            <!-- 二维码展示 -->
            <div class="m-pay-qrcode-large flex-center">
                <div class="m-pay-qrcode-border" :style="{'background': payMethod == 'wxpay_scan' ? '#00C277' : '#3D5EFF'}">
                    <div class="m-pay-qrcode-head flex-center">
                        <img v-if="payMethod" :src="require(`@/assets/image/pay_${payMethod}.png`)" alt="">
                    </div>
                    <div class="m-pay-qrcode">
                        <c-qrcode v-if="qrCodeUrl" :value="qrCodeUrl" size="200"></c-qrcode>
                        <div v-else class="m-pay-qrcode-empty flex-center">
                            <i class="tf-loading m-loading-icon"></i>
                            <span>二维码生成中...</span>
                        </div>
                    </div>
                </div>
                <p class="m-pay-scan-tip">请买方客户扫码付款</p>
                <p v-if="qrCodeUrl" class="m-pay-countdown">二维码有效时间剩余 {{countdownText}}</p>
            </div>
        </div>

        <!-- 关联订单 -->
        <div v-if="orders && orders.length" class="m-repay-pay-orders">
            <label class="m-repay-pay-orders-label">关联订单</label>
            <div class="m-order-list">
                <div v-for="order in orders" :key="order.order_id" class="m-order-item">
                    <span class="m-order-no">{{order.order_no}}</span>
                    <div class="m-order-info">
                        <m-product-info :name="order.product_name" :level="order.level_type" :code="order.produce_code" :imei="order.imei"></m-product-info>
                    </div>
                    <span class="m-order-amount">{{formatPrice(order.sale_price)}}</span>
                </div>
            </div>
        </div>

        <template #button>
            <c-button size="dialog" @click="closeDialog">取消</c-button>
        </template>
    </c-dialog>
</template>

<script>
    export default {
        name: 'creditRepaymentPay',

        props: {
            id: [String, Number],           //还款单ID
            record_no: String,              //还款单号
            amount: [String, Number],       //还款金额（元）
            orders: {                       //关联订单列表
                type: Array,
                default: () => []
            }
        },

        data() {
            return {
                payMethodOptions: [
                    {name: '微信扫码', value: 'wxpay_scan'},
                    {name: '支付宝扫码', value: 'alipay_scan'}
                ],
                payMethod: 'wxpay_scan',      //当前扫码方式
                qrCodeUrl: '',                //支付二维码链接
                fee: 0,                       //本次还款服务费（元）
                countdown: 600,               //二维码有效倒计时（秒）
                countdownTimer: null,
                pollTimer: null,
                pollRequest: null
            }
        },

        computed: {
            countdownText() {
                var minutes = Math.floor(this.countdown / 60);
                var seconds = this.countdown % 60;
                return minutes + '分' + (seconds < 10 ? '0' : '') + seconds + '秒';
            }
        },

        methods: {
            /*********打开弹窗**********/
            open() {
                this.payMethod = 'wxpay_scan';
                this.qrCodeUrl = '';
                this.fee = 0;
                this.countdown = 600;
                this.clearTimers();
                this.$refs.dialog.open({
                    title: '通联付款'
                });
                //默认生成微信扫码二维码
                this.loadQrCode();
            },

            /*********切换扫码方式，重新生成二维码**********/
            switchPayMethod(value) {
                if (this.payMethod == value) return;
                this.payMethod = value;
                this.qrCodeUrl = '';
                this.clearTimers();
                this.loadQrCode();
            },

            /*********调用通联消费接口生成付款二维码**********/
            loadQrCode() {
                this.request({
                    url: '/order/credit/repayment/consume/apply',
                    data: {
                        repayment_id: this.id,
                        pay_method: this.payMethod
                    },
                    loading: true,
                    success: data => {
                        if (data && data.payInfo) {
                            this.qrCodeUrl = data.payInfo;
                            this.fee = Number(data.fee || 0) / 100;   //服务费（分转元）
                            this.startCountdown();
                            this.checkPayStatus();
                        } else {
                            this.$message({message: '生成二维码失败', type: 'error'});
                        }
                    }
                    //失败时组件库默认弹出后端透出的错误信息（如：当前登录账号未开通通联账户）
                });
            },

            /*********开始倒计时**********/
            startCountdown() {
                clearInterval(this.countdownTimer);
                this.countdown = 600;
                this.countdownTimer = setInterval(() => {
                    this.countdown--;
                    if (this.countdown <= 0) {
                        this.clearTimers();
                        this.$message({message: '二维码已过期，请重新生成', type: 'warn'});
                    }
                }, 1000);
            },

            /*********轮询还款单状态，支付完成后刷新**********/
            checkPayStatus() {
                this.clearPoll();
                this.pollRequest = this.request({
                    url: '/order/credit/repayment/detail',
                    data: {
                        repayment_id: this.id
                    },
                    success: data => {
                        if (data && data.repayment_order_detail && data.repayment_order_detail.state == 2) {
                            this.clearTimers();
                            this.$message({message: '支付成功', type: 'success'});
                            this.$refs.dialog.close();
                            this.$emit('resolve');
                        } else {
                            this.pollTimer = setTimeout(this.checkPayStatus, 3000);
                        }
                    },
                    error: () => {
                        this.pollTimer = setTimeout(this.checkPayStatus, 3000);
                    }
                });
            },

            /*********清除轮询**********/
            clearPoll() {
                if (this.pollRequest) {
                    this.pollRequest.abort();
                    this.pollRequest = null;
                }
                if (this.pollTimer) {
                    clearTimeout(this.pollTimer);
                    this.pollTimer = null;
                }
            },

            /*********清除定时器**********/
            clearTimers() {
                if (this.countdownTimer) {
                    clearInterval(this.countdownTimer);
                    this.countdownTimer = null;
                }
                this.clearPoll();
            },

            /*********格式化价格**********/
            formatPrice(price) {
                if (price === null || price === undefined || price === '') return '-';
                return '¥' + parseFloat(price).toFixed(2);
            },

            /*********关闭弹窗**********/
            closeDialog() {
                this.clearTimers();
                this.$refs.dialog.close();
            }
        },

        beforeDestroy() {
            this.clearTimers();
        }
    }
</script>

<style lang="stylus" scoped>
    .m-repay-pay-body {
        padding: 0 24px;
    }

    .m-repay-pay-info {
        padding: 20px 0 4px;

        .m-repay-pay-info-label {
            font-size: 15px;
            color: #666;
        }

        .m-repay-pay-info-value {
            font-size: 28px;
            font-weight: bold;
            color: #F70000;
        }
    }

    .m-repay-pay-no {
        padding-bottom: 16px;
        font-size: 13px;
        color: #999;
        text-align: center;
    }

    .m-repay-pay-tabs {
        gap: 12px;
        padding-bottom: 16px;

        .m-repay-pay-tab {
            position: relative;
            padding: 6px 24px;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            font-size: 14px;
            color: #333;
            background: #fff;
            cursor: pointer;
            transition: all .2s;
            user-select: none;

            &:hover {
                border-color: #1890ff;
                color: #1890ff;
            }

            &.z-active {
                border-color: #1890ff;
                color: #1890ff;

                &::after {
                    content: '';
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    width: 0;
                    height: 0;
                    border-style: solid;
                    border-width: 0 0 10px 10px;
                    border-color: transparent transparent #1890ff transparent;
                }
            }
        }
    }

    .m-pay-qrcode-large {
        flex-direction: column;
        gap: 12px;
        padding-bottom: 16px;

        .m-pay-qrcode-border {
            border-radius: 8px;
            padding: 0 5px 5px;
        }

        .m-pay-qrcode-head {
            height: 40px;
            padding: 10px 0;
        }

        .m-pay-qrcode {
            width: 200px;
            height: 200px;
            padding: 12px;
            border-radius: 8px;
            background: #fff;
        }

        .m-pay-qrcode-empty {
            width: 100%;
            height: 100%;
            color: #999;
            font-size: 13px;

            .m-loading-icon {
                margin-right: 6px;
                animation: rotate 1s linear infinite;
            }
        }

        .m-pay-scan-tip {
            font-size: 18px;
            color: #FF5555;
        }

        .m-pay-countdown {
            font-size: 13px;
            color: #999;
        }
    }

    @keyframes rotate {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
    }

    .m-repay-pay-orders {
        border-top: 1px solid #eee;
        padding: 12px 24px 4px;

        .m-repay-pay-orders-label {
            display: block;
            margin-bottom: 8px;
            font-size: 14px;
            color: #333;
        }

        .m-order-list {
            max-height: 170px;
            overflow-y: auto;
        }

        .m-order-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 12px;
            margin-bottom: 8px;
            padding: 6px 20px;
            background: #fafafa;
            border-radius: 4px;
            font-size: 13px;

            &:nth-last-child(1) {
                margin-bottom: 0;
            }

            .m-order-no {
                flex-shrink: 0;
                width: 180px;
                color: #666;
            }

            .m-order-info {
                flex: 1;
                min-width: 0;
            }

            .m-order-amount {
                flex-shrink: 0;
                color: #333;
                font-weight: bold;
            }
        }
    }
</style>
